import { render, staticRenderFns } from "./TitleModuleEditor.vue?vue&type=template&id=5de4b050&scoped=true"
import script from "./TitleModuleEditor.vue?vue&type=script&lang=js"
export * from "./TitleModuleEditor.vue?vue&type=script&lang=js"
import style0 from "./TitleModuleEditor.vue?vue&type=style&index=0&id=5de4b050&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de4b050",
  null
  
)

export default component.exports